import type React from "react";
import SimpleNameTable from "../common/SimpleNameTable";
import CreateCityForm from "./CreateCityForm";

interface City {
  _id: string;
  name: string;
  initiallyCreatedFrom?: "MANUAL" | "LOGISLY";
}

interface CityTableProps {
  items: City[];
  loading?: boolean;
  onEdit?: (cityId: string, newName: string) => Promise<void>;
  canEdit?: boolean;
}

const CityTable: React.FC<CityTableProps> = ({ items, loading, onEdit, canEdit = false }) => {
  return (
    <SimpleNameTable
      items={items}
      loading={loading}
      onEdit={onEdit}
      canEdit={canEdit}
      showSource
      EditFormComponent={CreateCityForm}
    />
  );
};

export default CityTable;
